import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "className", "icon", "renderIcon", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { clsx, cssClass } from "../utils.js";
export var IconButton = React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      className = _ref.className,
      Icon = _ref.icon,
      renderIcon = _ref.renderIcon,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("button", _objectSpread({
    ref: ref,
    type: "button",
    "aria-label": label,
    className: clsx(cssClass("button"), className),
    onClick: onClick
  }, rest), renderIcon ? renderIcon() : React.createElement(Icon, {
    className: cssClass("icon")
  }));
});
IconButton.displayName = "IconButton";